import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-view-subscription',
  templateUrl: './view-subscription.component.html',
  styleUrls: ['./view-subscription.component.scss'],
})
export class ViewSubscriptionComponent implements OnInit {
  @Output() closeActivityAtDialog: EventEmitter<any> = new EventEmitter();

  windowRef: any;
  subscription: any;
  isLoading: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<ViewSubscriptionComponent>,
    public as: AppService,
    public appService: AppService,
    public routes: ActivatedRoute,

    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.subscription = this.data['subscription'];
    this.windowRef = this.as.windowRef;
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {}

  close() {
    this.dialogRef.close();
    this.closeActivityAtDialog.emit(null);
  }
}
